import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';
import styled from 'styled-components';
import { media } from 'styles/breakpoints';

import ImageCard from 'components/ImageCard/ImageCard';

// services
import { track } from 'services/analytics';
import { EVENTS, SOURCES } from 'services/analytics-constants';

const Container = styled.div`
  &:not(:last-child) {
    margin-bottom: 100px;
  }
`;

const CardWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

// TODO: Refactor into shared Header Component
const Header = styled.h1`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  margin: 45px 0;
  text-align: center;
`;

// TODO: Refactor into shared Text Component
const Text = styled.p`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  font-size: 20px;
  line-height: 30px;
  text-align: justify;

  ${media.small`
    max-width: 75%;
    margin: 60px auto;
  `};
`;

export default function TakeActionList({ body, header, items }) {
  if (!items || !items.size) return null;
  return (
    <Container>
      {header && <Header>{header}</Header>}
      {body && body.map(paragraph => <Text>{paragraph}</Text>)}
      <CardWrap>
        {items.map(item => (
          <ImageCard
            key={item.get('link')}
            description={item.get('description')}
            imageUrl={item.get('imageUrl')}
            onClick={() =>
              track(EVENTS.CLICK_ACTION_CARD, {
                actionTitle: item.get('title'),
                actionUrl: item.get('link'),
                source: SOURCES.TAKE_ACTION
              })
            }
            title={item.get('title')}
            url={item.get('link')}
          />
        ))}
      </CardWrap>
    </Container>
  );
}

TakeActionList.propTypes = {
  items: ImmutablePropTypes.map
};

TakeActionList.defaultProps = {
  items: new List()
};



// WEBPACK FOOTER //
// ./src/views/TakeAction/TakeActionSection.js